import {useEffect} from 'react'
//images
import EmptyStar from '../../../../images/reviews/star-border.svg'
import FullStar from '../../../../images/reviews/star-full.svg'

//styles
import '../../styles/input/custom-input.css'

const CustomRating = ({label,value,setValue,requiredValue,labelSize,isDisabled}) => {

  // useEffect(() => {
  //   console.log('labelSize',labelSize)
  // }, [labelSize])
  

 const selectedRate = index => {
    setValue(index+1)
 }
 const StarsGenerator = ({qty}) => {
      const stars = []
      for(let i = 0; i < 5; i++)
      {
        if(i < qty)
        {
          stars.push(
            <img onClick={_=>selectedRate(i)} key={`${label}_star_${i}`} src={FullStar} alt="fullstar"/>
          )
        }
        else{
          stars.push(
            <img onClick={_=>selectedRate(i)} key={`${label}_star_${i}`} src={EmptyStar} alt="emptystar"/>
          )
        }
      }
      return <div style={{whiteSpace:'nowrap'}}>{stars}</div>
    }
  return (
    <div className='custom-input' style={labelSize ? {gridTemplateColumns: `${labelSize} calc(100% - ${labelSize} - 20px)`} : {}}>
        {label && <div className='custom-input__label'>{label}:{requiredValue ? <span>*</span> : ''}</div>}
        <div>
            <StarsGenerator qty={value}/>
        </div>
    </div>
  )
}

export default CustomRating